/* Read the same variant input as add-to-cart. No price, option or cart mutations. */
if (!customElements.get('elix-variant-coa')) {
  customElements.define('elix-variant-coa', class extends HTMLElement {
    connectedCallback() {
      if (this.coaReady) return;
      this.coaReady = true;
      this.root = this.closest('.elix-product');
      this.link = this.querySelector('[data-coa-link]');
      this.dosage = this.querySelector('[data-coa-dosage]');
      this.map = JSON.parse(this.querySelector('[data-coa-map]').textContent);
      this.sync = () => {
        const id = this.root?.querySelector('[data-variant-id]')?.value;
        const certificate = this.map[id];
        this.link.hidden = !certificate;
        if (certificate) {
          this.link.href = certificate.url;
          this.dosage.textContent = ' — ' + certificate.dosage;
        } else {
          this.link.removeAttribute('href');
          this.dosage.textContent = '';
        }
      };
      // The existing option-button handler runs on the target first, then this
      // bubbling listener reads its final variant value synchronously.
      this.onOption = (event) => {
        if (event.target.closest('[data-option-value]')) this.sync();
      };
      this.root?.addEventListener('click', this.onOption);
      this.root?.addEventListener('change', this.sync);
      this.sync();
    }
    disconnectedCallback() {
      this.root?.removeEventListener('click', this.onOption);
      this.root?.removeEventListener('change', this.sync);
      this.coaReady = false;
    }
  });
}
